import { render } from "./EditLeaveType.vue?vue&type=template&id=a7f7cce0&scoped=true"
import script from "./EditLeaveType.vue?vue&type=script&lang=js"
export * from "./EditLeaveType.vue?vue&type=script&lang=js"

import "./leave-type.scss?vue&type=style&index=0&id=a7f7cce0&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f7cce0"]])

export default __exports__